<section class="notification-panel" aria-labelledby="notification-panel-title">
  <header class="notification-panel__header">
    <span class="notification-panel__icon"><mat-icon aria-hidden="true">notifications</mat-icon></span>
    <h2 id="notification-panel-title">Notifiche</h2>
    <button type="button" (click)="toggleSidebarOpen('quickPanel')" mat-icon-button aria-label="Chiudi notifiche">
      <mat-icon aria-hidden="true">arrow_forward</mat-icon>
    </button>
  </header>

  <div class="notification-panel__date">
    <span class="notification-panel__weekday">{{ date | date: 'EEEE' }}</span>
    <span>{{ date | date: 'd MMMM' }}</span>
  </div>

  <div class="notification-panel__list" tabindex="0" role="region" aria-label="Elenco notifiche">
    @if (notificationState === 'loading') {
      <p class="notification-panel__status" role="status" aria-live="polite">
        <span class="notification-panel__loader" aria-hidden="true"></span>
        Caricamento notifiche…
      </p>
    } @else if (notificationState === 'error') {
      <div class="notification-panel__error" role="alert">
        <p>Impossibile caricare le notifiche.</p>
        <button type="button" mat-button (click)="getListaNotifiche()">Riprova</button>
      </div>
    } @else if (notificationState === 'loaded') {
      <ul>
        @for (group of [notificationsNew, notificationsRead.slice(0, 5)]; track $index) {
          @for (item of group; track item) {
            <li class="notification-item" [class.notification-item--unread]="!item.is_letta">
              <button type="button" class="notification-item__open" (click)="setNotificaLetta(item)">
                <span class="notification-panel__icon">
                  <mat-icon aria-hidden="true">chat_bubble_outline</mat-icon>
                </span>
                <span class="notification-item__content">
                  <span class="notification-item__meta">
                    {{ item.data_creazione | dataFormatted }} • {{ item.piattaforma }}
                  </span>
                  <span class="notification-item__text">{{ item.testo_notifica }}</span>
                </span>
              </button>
              @if (!item.is_letta) {
                <button
                  type="button"
                  mat-icon-button
                  class="notification-item__mark-read"
                  (click)="setNotificaLetta(item, false)"
                  matTooltip="Segna come già letta"
                  [attr.aria-label]="'Segna come già letta: ' + item.testo_notifica"
                >
                  <span class="notification-item__dot" aria-hidden="true"></span>
                </button>
              }
            </li>
          }
        }
      </ul>
      @if (!notificationsNew.length && !notificationsRead.length) {
        <p class="notification-panel__empty">Nessuna notifica da mostrare.</p>
      }
    }
  </div>

  <footer class="notification-panel__footer">
    <button type="button" mat-button (click)="visualizzaTutteNotifiche()">
      Vedi tutte le notifiche
      <mat-icon iconPositionEnd aria-hidden="true">chevron_right</mat-icon>
    </button>
  </footer>
</section>
